import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ...mapGetters({
            keycloakConfig: 'keycloakAuth/Config',
            keycloakInstance: 'keycloakAuth/Instance',
        }),
    },
    methods: {
        ...mapActions({
            SetKeycloakURL: 'keycloakAuth/SetKeycloakURL',
            SetKeycloakRealm: 'keycloakAuth/SetKeycloakRealm',
            SetKeycloakClientID: 'keycloakAuth/SetKeycloakClientID',
            SetKeycloakInstance: 'keycloakAuth/SetKeycloakInstance',
        }),
        async SignIn() {
            eventBus.$emit('sign-in:keycloak:started');

            try {
                await this.keycloakInstance
                    .init({ onLoad: 'login-required', redirectUri: window.location.origin });
            }
            catch (ex) {
                eventBus.$emit('sign-in:keycloak:error', ex);

                this.InitialiseKeycloakInstance();

                await this.keycloakInstance
                    .init({ onLoad: 'login-required', redirectUri: window.location.origin });
            }
        },
        async CheckSSO() {
            if ((this.keycloakInstance?.authenticated ?? false) === false) {
                try {
                    const authenticated = await this.keycloakInstance
                        .init({ onLoad: 'check-sso' });

                    if (authenticated) {
                        eventBus.$emit('check-sso:keycloak:success');
                        setInterval(() => this.keycloakInstance.updateToken(70), 60000);
                    }
                    else eventBus.$emit('check-sso:keycloak:error');
                }
                catch (ex) {
                    eventBus.$emit('check-sso:keycloak:error', ex);
                }
            }
            else eventBus.$emit('check-sso:keycloak:success');
        },
        SignOut() {
            this.keycloakInstance.logout({ redirectUri: window.location.origin });
        }
    }
};